import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import useEmblaCarousel from "embla-carousel-react";
import StepsBg from "@/assets/images/steps-bg.png";
import Step01 from "@/assets/images/step01.png";
import Step02 from "@/assets/images/step02.png";
import Step03 from "@/assets/images/step03.png";
import Div100vh from "react-div-100vh";
import { trackBtnClick } from "@/lib/helper";
import Header from "../common/Header/header";

const Stepper = ({ steps, currentStep }) => {
  return (
    <div className="flex items-center justify-center space-x-3 my-4">
      {Array.from({ length: steps }, (_, index) => {
        const isActive = index === currentStep;
        // const isCompleted = index < currentStep;

        return (
          <div key={index} className="flex justify-center h-8 items-center">
            <span
              className={`rounded-full ${
                isActive ? "bg-white w-36 h-1.5" : "bg-[#434343] w-12 h-1.5"
              }`}
            />
          </div>
        );
      })}
    </div>
  );
};

export default function FurtherSteps() {
  const navigate = useNavigate();
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    align: "center",
  });
  const [currentStep, setCurrentStep] = useState(0);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setCurrentStep(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    emblaApi.on("select", onSelect);
    onSelect(); // Set initial state
  }, [emblaApi, onSelect]);

  const handleNext = () => {
    if (emblaApi && currentStep < 2) {
      emblaApi.scrollNext(); // Move to the next slide
    } else {
      trackBtnClick("Next", "Steps Screen");
      navigate("/landlord-details"); // Navigate to the next page if on the last step
    }
  };

  return (
    <Div100vh
      className="flex flex-col bg-[#010101] bg-no-repeat bg-cover justify-between py-4 px-2"
      style={{
        backgroundImage: `linear-gradient(to bottom, rgba(1, 1, 1, 1) 10%, rgba(1, 1, 1, 1) 0%, rgba(1, 1, 1, 0) 100%), url(${StepsBg})`,
      }}
    >
      <div className="flex flex-col gap-8">
        <Header />
        <Stepper steps={3} currentStep={currentStep} />
        {/* Embla Carousel */}
        <div className="overflow-hidden" ref={emblaRef}>
          <div className="flex gap-4">
            <div className="embla-slide shrink-0 w-[90%]">
              <img src={Step01} alt="Step 1" className="rounded-lg max-w-full pointer-events-none select-none" />
            </div>
            <div className="embla-slide shrink-0 w-[90%]">
              <img src={Step02} alt="Step 2" className="rounded-lg max-w-full pointer-events-none select-none" />
            </div>
            <div className="embla-slide shrink-0 w-[90%]">
              <img src={Step03} alt="Step 3" className="rounded-lg max-w-full pointer-events-none select-none" />
            </div>
          </div>
        </div>
      </div>

      {/* Always-visible Button */}
      <button
        onClick={handleNext}
        className="flex gap-2 text-black bg-primary-100 font-semibold rounded-full text-base px-5 py-3 mx-8 text-center items-center justify-center"
      >
        {currentStep < 2 ? "Next" : "Finish"}
        {/* <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-move-right"
        >
          <path d="M18 8L22 12L18 16" />
          <path d="M2 12H22" />
        </svg> */}
      </button>
    </Div100vh>
  );
}
